export function waitForFonts(): Promise<void> {
  if (document.fonts && document.fonts.ready) {
    return document.fonts.ready.then(() => undefined);
  }

  return new Promise<void>((resolve) => {
    const timeout = setTimeout(() => {
      resolve();
    }, 3000);

    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(() => {
        clearTimeout(timeout);
        resolve();
      }).catch(() => {
        clearTimeout(timeout);
        resolve();
      });
    } else {
      if (document.readyState === 'complete') {
        setTimeout(() => {
          clearTimeout(timeout);
          resolve();
        }, 100);
      } else {
        window.addEventListener('load', () => {
          setTimeout(() => {
            clearTimeout(timeout);
            resolve();
          }, 100);
        });
      }
    }
  });
}

export function areFontsLoaded(): boolean {
  if (!document.fonts) {
    return false;
  }

  const authorFonts: string[] = [
    'Playfair',
    'Stack',
  ];

  try {
    return authorFonts.every((fontFamily: string) =>
      document.fonts.check(`16px ${fontFamily}`)
    );
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error('Error checking if fonts are loaded', error);
    return false;
  }
}